import { useGetMiddeskStatusQuery } from 'src/api';

export const useGetMiddeskStatus = () => {
  const { data } = useGetMiddeskStatusQuery();
  return data?.getMiddeskStatus.isMiddeskEnabled || false;
};
